import './styles.scss';


const Notification = ({ children }) => (
    <div className='notification-container'>
        <span className='notification'>{children}</span>
    </div>
)

export default Notification;